export default __webpack_public_path__ + "static/media/build.304cbc41.webp";